import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Partners } from '@com-delta-omnichannel/aura';
import { StateFacade } from '../../data-access/+state/facades/state.facade';
import { PartnerAnalytics } from '../../data-access/models/partners-promotions.interfaces';

@Component({
  selector: 'idp-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {
  @Input() showLinked = false;
  @Output() clickAnalyticsEvent = new EventEmitter<PartnerAnalytics>();

  constructor(public partners: StateFacade) {}

  ngOnInit() {
    this.partners.init(this.showLinked);
  }

  redirect(link: string) {
    window.open(link, '_blank');
  }

  getAnalyticsData(url: string, content: Partners) {
    let isPartnerCard = false;
    content.items.forEach((item, index) => {
      if (item.action.url === url) {
        isPartnerCard = true;
        const partnerName = item.logo.alt.split(' ').slice(0, -2).join(' ');
        this.clickAnalyticsEvent.emit({
          index,
          label: partnerName,
          length: content.items.length,
          title: content.title,
          id: 'skymiles_partners'
        });
      }
    });
    if (!isPartnerCard) {
      this.clickAnalyticsEvent.emit({
        index: 0,
        id: 'skymiles_partners',
        label: content.action.label,
        length: 0,
        title: content.title
      });
    }
  }
}
